export const getParsedPayloadAsTrucks = (unparsedPayload) => {
  let trucks = {};
  unparsedPayload.forEach((payload) => {
    if (!(payload.vehicle_id in trucks)) {
      trucks[payload.vehicle_id] = [];
    }
    trucks[payload.vehicle_id].push(payload);
  });

  return Object.values(trucks).map((truck) => {
    return truck.map((payload) => {
      return [
        `Truck Nr. ${payload.vehicle_id}`,
        payload.payload_id,
        addMinuteToDateObject(payload.start_time_abs),
        addMinuteToDateObject(payload.end_time_abs),
      ];
    });
  });
};

export const getPayloadByDateRange = (dateStart, dateEnd, initialPayload) => {
  console.log("initial payload", initialPayload);

  initialPayload.filter(
    (payload) =>
      typeof payload[0] === "object" ||
      (payload[2].toString() > dateStart.toString() &&
        payload[3].toString() < dateEnd.toString())
  );
  return initialPayload;
};

export const preparePayload = (truckList) => {
  let data = [
    [
      { type: "string", id: "TruckId" },
      { type: "string", id: "Task" },
      { type: "date", id: "Start" },
      { type: "date", id: "End" },
    ],
  ];
  truckList.forEach((trucks) => {
    trucks.forEach((truck) => {
      data.push(truck);
    });
  });
  return data;
};

export const addMinuteToDateObject = (minutes) => {
  return new Date(getDefaultDate().getTime() + minutes * 60000);
};

export const getDefaultDate = () => {
  return new Date(2021, 10, 1);
};
